import { render, staticRenderFns } from "./ShareNotification.vue?vue&type=template&id=1776ef90&scoped=true"
import script from "./ShareNotification.vue?vue&type=script&lang=js"
export * from "./ShareNotification.vue?vue&type=script&lang=js"
import style0 from "./ShareNotification.vue?vue&type=style&index=0&id=1776ef90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776ef90",
  null
  
)

export default component.exports